export { recomputeLine, recomputePayload } from "./create-einvoice-utils";

export function formatVND(amount: number): string {
  return new Intl.NumberFormat("vi-VN", {
    style: "currency",
    currency: "VND",
    minimumFractionDigits: 0,
    maximumFractionDigits: 6,
  }).format(amount);
}

export function formatVatVND(amount: number): string {
  return new Intl.NumberFormat("vi-VN", {
    style: "currency",
    currency: "VND",
    minimumFractionDigits: 0,
    maximumFractionDigits: 6,
  }).format(amount);
}

export function formatCurrency(amount: number, currencyCode = "VND"): string {
  const locale = currencyCode === "VND" ? "vi-VN" : "en-US";
  return new Intl.NumberFormat(locale, {
    style: "currency",
    currency: currencyCode,
    minimumFractionDigits: 0,
    maximumFractionDigits: 6,
  }).format(amount);
}
